var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("TABLE_HEADER_fileNameList"),
            visible: "",
            width: "70%",
            top: "10vh",
          },
          on: { close: _vm.onCancel },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                border: "",
                "row-class-name": _vm.tableRowClassName,
                data: _vm.paginationData,
                "max-height": "500",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                  "class-name": "file-name-cell",
                  label: _vm.$t("DOWNLOAD_FILE_NAME"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.calcDisableDownload(scope.row)
                          ? _c("span", [_vm._v(_vm._s(scope.row.name))])
                          : _c(
                              "span",
                              {
                                staticClass: "file-name can-download",
                                on: {
                                  click: function ($event) {
                                    return _vm.onFileDownload(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-download" }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(scope.row.name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "size",
                  width: "100",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_SIZE"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("fileSize")(scope.row.size))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadDate",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_TIME"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadBy",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("DOWNLOAD_BY"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uploadDate",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("UPLOAD_TIME"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uploadBy",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("UPLOAD_BY"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              scope.row.uploadBy === "System synchronisation"
                                ? _vm.$t("admin.System synchronisation")
                                : scope.row.uploadBy
                            ) +
                            "\n                    "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "history",
                  width: "85",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("VERSION_HISTORY"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.hasHistory && scope.row.hasHistory === "YES"
                          ? _c("i", {
                              staticClass: "el-icon-document pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.queryFileHistory(
                                    scope.row.name,
                                    scope.row.groupEntityTopicId
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm.isKpmgUser
                ? _c("el-table-column", {
                    attrs: {
                      prop: "action",
                      width: "70",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("COMMON_DELETE"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("i", {
                                staticClass: "el-icon-delete delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.onDeleteClick(scope.row)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3227689491
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              total: _vm.total,
              "current-page": _vm.current,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.historyVisible
        ? _c("file-history", {
            attrs: {
              tableData: _vm.historyData,
              curUserName: _vm.curUserName,
              downloadAble: _vm.downloadAble,
              onCancel: _vm.toogleFileHistoryVisible,
            },
            on: {
              "on-file-download": (row) => _vm.onFileDownload(row),
              queryFileHistory: (row) =>
                _vm.queryFileHistory(row.name, row.groupEntityTopicId),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }